import { Box, Grid, Typography } from '@mui/material';

import Chip from '@/components/ui/Chip/Chip';
import useFormatMessage from '@/hooks/useFormatMessage';

import { Title } from './Heading.style';

const Heading = () => {
  const formatMessage = useFormatMessage();

  return (
    <Box mt={6} mb={11.5}>
      <Chip
        size="small"
        uppercase
        sx={{
          mb: 2.5,
        }}>
        {formatMessage('blog_headingChip')}
      </Chip>
      <Title component="h1" variant="h1Redesign" color="primary.dark" mb={4}>
        {formatMessage('blog_heading')}
      </Title>
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={4}>
          <Typography
            component="h2"
            variant="h5Redesign"
            color="text.secondary">
            {formatMessage('blog_subheading')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography
            component="p"
            variant="body1Redesign"
            color="text.secondary">
            {formatMessage('blog_headingText')}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Heading;
